module.exports = __webpack_public_path__ + "static/media/work (4).b25721c1.jpg";